import React from 'react'
import './entryAndDepartureMobile.css';
import ItemSelectableSimple from '../../ItemSelectable/ItemSelectableSimple';
import { getDateOrTimeToReport, getIconByResoruce } from '../entryAndDepartureHelper';
import { t } from 'i18next';

export const EntryAndDepartureCardMobile = ({ data, setShowDetailModal, setResourceInfo }) => {

    const showResourceDetail = () => {
        setResourceInfo({
            access_resource_id: data.access_resource_id,
            resource_type: data.resource_type,
            status: data.status
        });
        setShowDetailModal(true);
    }

    return (
        <div className='mt-2'>
            <ItemSelectableSimple onClick={showResourceDetail}>

                <div className='d-flex align-items-center w-100'>
                    <div>
                        <div className='d-flex mb-1 text-start'>
                            <div className='p-1 me-2 '>
                                <img src={require(`../../../assets/icons/${getIconByResoruce(data.resource_type)}`)} alt="userIcon" />
                            </div>
                            <div>
                                <p className='m-0 title-resource'>{data.name ? data.name : '-'}</p>
                                <div className='d-flex'>
                                    <p className='m-0 subtitle-mobile' >{`${t('ID')} ${data.natural_id ? data.natural_id : '-'}`}</p>
                                    <p className='m-0 subtitle-mobile ms-1 me-1' >|</p>
                                    <p className='m-0 info-movement-mobile'>{data.contractor_name ? data.contractor_name : '-'}</p>
                                </div>
                            </div>
                        </div>

                        <div className='d-flex justify-content-around align-items-center'>

                            <div className='me-3'>
                                <p className='m-0 '>{t('ENTRY')}</p>
                                <div className='d-flex'>
                                    <p className='m-0 info-movement-mobile me-2 '>{data.entry_date ? getDateOrTimeToReport(data.entry_date, 'DATE', false) : '-'}</p>
                                    <p className='m-0 info-movement-mobile '>{data.entry_date ? getDateOrTimeToReport(data.entry_date, 'TIME', false) : '-'}</p>
                                </div>
                            </div>

                            <div>
                                <p className='m-0 '>{t('DEPARTURE')}</p>
                                <div className='d-flex'>
                                    <p className='m-0 info-movement-mobile me-2 '>{data.egress_date ? getDateOrTimeToReport(data.egress_date, 'DATE', false) : '-'}</p>
                                    <p className='m-0 info-movement-mobile '>{data.egress_date ? getDateOrTimeToReport(data.egress_date, 'TIME', false) : '-'}</p>
                                </div>
                            </div>

                        </div>

                    </div>
                </div>

            </ItemSelectableSimple>

        </div>
    )
}
